import { ComponentManager, RuntimeEngine } from '@easytwin/runtime';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';
import { useMainScene } from './useMainScene';

export const useGetRootComponent = (engine: RuntimeEngine | undefined) => {
  const scene = useMainScene(engine);
  const refresh = useDumbState();
  const componentMgr = scene?.getManager(ComponentManager);
  useBindSignal(componentMgr?.signals.componentsUpdated, refresh);

  const rootComp = componentMgr?.rootComponent;
  return rootComp;
};
